import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CoreModule } from 'dbweb-core';
import { ClipboardModule } from 'ngx-clipboard';
import { HomeComponent } from './home.component';
import { HomeNavComponent } from './nav-itemn/home-nav.component';
import { MenuComponent } from './nav-itemn/nav-menu/menu.component';
import { NavSelectionDeptComponent } from './nav-itemn/nav-selection-dept/nav-selection-dept.component';
import { RouterTab, RouterTabComponent, RouterTabItem } from './router-tab/router-tab.component';
import { SetDeptModule } from './set-dept/set-dept.module';
@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		ClipboardModule,
		RouterModule,
		MatIconModule,
		MatToolbarModule,
		MatSidenavModule,
		MatButtonModule,
		MatMenuModule,
		MatDividerModule,
		MatTreeModule,
		MatBadgeModule,
		FormsModule,
		MatTabsModule,
		CoreModule,
		MatRippleModule,
		BrowserAnimationsModule,
		DragDropModule,
		MatDialogModule,
		SetDeptModule
	],
	declarations: [
		HomeComponent,
		HomeNavComponent,
		MenuComponent,
		RouterTabComponent,
		RouterTabItem,
		RouterTab,
		NavSelectionDeptComponent
	],
	exports: [HomeComponent, RouterTabComponent, RouterTabItem, RouterTab],
	entryComponents: [HomeNavComponent]
})
export class HomeModule {}
